import { useEffect } from 'react';
import { compareWithAppVersion } from '@croquiscom/web2app';

import { isZigzag } from '@common/device-manager';
import { Typography } from '@common/styles';
import { FaceButtonColor, FaceButtonSize } from '@common/toolbox';

import { UnregisteredSize } from '../components/UnregisteredSize';
import { useLegacySizeRecommendationUBL } from '../services/useLegacySizeRecommendationUBL';
import { useLegacyUnregisteredSizeService } from '../services/useLegacyUnregisteredSizeService';

export const LegacyUnregisteredSizeContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isBodyInfoShown, refetch, setIsBodyInfoShown, handleBodyInfoClick, targetRef, sizeRecommendExampleImage } =
    useLegacyUnregisteredSizeService();
  const { inputBodyInfoClick } = useLegacySizeRecommendationUBL();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && isBodyInfoShown) {
        refetch();
        setIsBodyInfoShown(false);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBodyInfoShown]);

  if (isZigzag() && !compareWithAppVersion('6.84.0')) {
    return null;
  }

  return (
    <UnregisteredSize>
      <UnregisteredSize.Wrapper ref={targetRef}>
        <UnregisteredSize.Title className={Typography.BODY_17_BOLD}>
          신체정보를 입력해주세요.
          <br />
          <UnregisteredSize.Subtitle className={Typography.BODY_14_REGULAR}>
            신체정보를 입력하면 사이즈를 제안 받을 수 있어요.
          </UnregisteredSize.Subtitle>
        </UnregisteredSize.Title>
        <UnregisteredSize.Button
          type='button'
          onClick={() => {
            inputBodyInfoClick();
            handleBodyInfoClick();
          }}
          className='button'
          color_type={FaceButtonColor.GRAY900}
          size_type={FaceButtonSize.S13_H32}
        >
          정보 입력하기
        </UnregisteredSize.Button>
        <img src={sizeRecommendExampleImage} alt='사이즈 추천 예시 이미지' />
      </UnregisteredSize.Wrapper>
    </UnregisteredSize>
  );
};
